import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { log } from '@root/util/logger';

@Component({
  selector: 'host-hour-room-calendar',
  templateUrl: './hour-room-calendar.component.html',
  styleUrls: ['./hour-room-calendar.component.scss']
})
export class HourRoomCalendarComponent implements OnInit, OnChanges {
  private readonly timelineHeight = 30;
  private readonly settingApi = '/api/house_status_setting/get';
  private rangeStart: Moment;
  private rangeEnd: Moment;
  channelColorMap = {};
  @Input('currentReservation') selectedReservation = null;
  @Input() checkinReservation = null;
  @Input() checkoutReservation = null;
  @Input('listOfOrder') hourReservations = [];
  @Output() onDoubleClick = new EventEmitter();
  @Output() onReservationClick = new EventEmitter<string>();

  listOfAllReservation = [];

  get listOfTimeline () {
    const result = [];
    if (this.rangeStart && this.rangeEnd) {
      const start = this.rangeStart.clone();
      while (start.isSameOrBefore(this.rangeEnd, 'm')) {
        result.push(start.format('YYYY-MM-DD HH:mm'));
        start.add(1, 'h');
      }

      /** 不足一小时的补足一小时 */
      // if (start.diff(this.rangeEnd, 'm') < 60) {
      //   result.push(start.format('YYYY-MM-DD HH:mm'));
      // }
    }
    return result;
  }

  constructor(
    private http: HttpClient
  ) { }
  ngOnInit() {
    this.fetchSetting();
  }

  ngOnChanges (changes: SimpleChanges) {
    const value = changes['hourReservations'];
    if (!value) {
      return;
    }

    if (value['currentValue'] !== value['previousValue']) {
      this.initOrdersInfo();
    }
  }

  dbClick () {
    log('dbclick');
    this.onDoubleClick.emit();
  }

  clickReservation (code: string) {
    log('reservation click: ', code);
    this.onReservationClick.emit(code);
    this.selectedReservation = code;
  }

  private initOrdersInfo () {
    /** 标准化订单的时间格式，并排序 */
    const unifiedReservation = this.unifiedHourReservationsTimeFormat(this.hourReservations);
    const orderedReservation = this.sortHourReservationsByTime(unifiedReservation);

    this.listOfAllReservation = this.concatAllReservations(orderedReservation, this.checkinReservation, this.checkoutReservation);

    log('hour-calendar: all reservations: ', this.listOfAllReservation);

    [ this.rangeStart, this.rangeEnd ] = this.findOrdersRange(this.listOfAllReservation);
    /** 找到订单中所有的互相冲突的订单 */
    const list = this.findOrdersConflictWithEachOther(this.listOfAllReservation);
    log('[hour-calendar] conflict with each other:: ', list);
    // console.log('[hour-calendar] conflict with each other:: ', list);
    /** 遍历互相冲突的订单 */
    list.forEach((group, index) => {
      console.group('index' + index);
      // log('[hour-calendar] group start ======================: ', group.map(i => ({
      //   name: i.client.name,
      //   start: i.start,
      //   end: i.end,
      //   index: i._index_,
      //   width: i._width_
      // })));
      /** 为每个冲突订单确定自己的位置 */
      this.determineOrdersPosition(group);

      /** 重新根据位置排列每个冲突订单 */
      const sortedGroup = this.sortOrdersByPosition(group);

      /** 此时顺序已确定，根据位置确定样式 */
      this.determineOrdersStyle(sortedGroup);
      // log('[hour-calendar] group end ======================: ', group.map(i => ({
      //   name: i.client.name,
      //   start: i.start,
      //   end: i.end,
      //   index: i._index_,
      //   width: i._width_
      // })));
      console.groupEnd();
    });

    log('[hour-calendar] this.listOfOrder: ', this.listOfAllReservation);
  }

  /**
   * 根据情况，为数组中未分配值的位置分配适当的值
   * @TODO 有更好的方法？
   *  */
  private allocateIndex (list): Array<number> {
    const total = list.length;

    // const waitAllocated = list.filter(i => i === undefined).length;
    const allocated = list.filter(i => i !== undefined).sort((a, b) => a - b);
    const waitAllocated = total - allocated.length;

    if (waitAllocated === 0) {
      return [];
    }

    const min = Math.min.apply(null, allocated);
    const max = Math.max.apply(null, allocated);

    const result = Array(waitAllocated).fill(0);

    if (total === waitAllocated) {
      return result.map((item, index) => index);
      // result[0] = 0;
    } else {
      //#region new
      // 遵循向左优先的原则，尽量往左放
      const parts = this.splitNumbersByContinuity(allocated);
      log('[hour-calendar] parts: ', parts);
      if (parts.length === 1) { // 连续的 [1,2,3]
        const part = parts[0];

        const min = Math.min.apply(null, part);
        const max = Math.max.apply(null, part);

        if (min !== 0) { // [ 1,2,3 ]
          return result.map((item , index) => min / waitAllocated * index);
        } else { // [0, 1, 2, 3]
          return result.map((item, index) => max + index + 1);
        }
      } else { // 不连续 [ [0, 1], [4, 5] ] 或者 [ [1, 2], [4, 5] ]
        const firPart = parts[0];
        const secPart = parts[1];

        const min = Math.max.apply(null, firPart);
        const max = Math.min.apply(null, secPart);

        if (firPart[0] !== 0) { // [ [1, 2], [4, 5] ]
          return result.map((item , index) => firPart[0] / waitAllocated * index);
        } else { // [ [0, 1], [4, 5] ]
          if (max - min > waitAllocated) {
            return result.map((i, index) => min + 1 + index);
          } else {
            return result.map((i, index) => min + (max - min) / (waitAllocated + 1) * (index + 1));
          }
        }

      }

      return;
      //#endregion


      /// 补位说明，存在的几种情况
      /// 1,已分配的不连续，未分配的有两种情况
      /// [ 0, 2, 4, undefined ]   ->  1
      /// [ 0, 2, 4, undefined, undefined, ..] -> (2 - 0) / (waitAllocated + 1) * (index + 1)
      /// 2,已分配的连续，未分配的有两种情况
      /// [ 0, 1, undefined]
      /// [ 0, undefined, undefined, undefined, ..]

      /// [ 1, 3, 4, undefined, ... ]
      /// [ 1, 3, undefined, undefined, ... ]
      /// [ 1, 2, undefined, undefined, ... ]
      /// [ 1, undefined, undefined, ...]
      if (min === 0) {
        if (waitAllocated === 1) {
          return [1];
        } else {

          if (max - min !== 1 && max !== 0) { // [ undefined, 3, 0, undefined, undefined ]
            return result.map((item, index) => (max - min) / (waitAllocated + 1) * (index + 1));
          } else { // [ undefined, 1, 0, undefined, undefined]  [ undefined, 0, undefined, undefined]
            return result.map((item , index) => max + index + 1)
          }
        }

      } else { // [undefined, undefined, 1, 2, 3]
        return result.map((item, index) =>  min / waitAllocated * index)
      }

    }

  }

  private splitNumbersByContinuity (array: Array<number>): Array<Array<number>> {
    const result = [];
    let temp = [];

    array
      .sort((a, b) => a - b)
      .concat(Infinity)
      .reduce((acc, cur) => {
        temp.push(acc);

        if (cur - acc > 1) {
          result.push(temp);
          temp = [];
        }

        return cur;
      });

    if (_.isEmpty(result)) {
      return [ array ];
    }

    return result;
  }


  private findOrdersRange (list) {

    if (list.length === 0) {
      return [ null, null ];
    }

    let start, end;
    list.forEach((item, index) => {

      const os = moment(item.start);
      const oe = moment(item.end)

      if (!start && !end) {
        start = os;
        end = oe;
      } else {
        if (os.isBefore(start, 'm')) {
          start = os;
        }

        if (oe.isAfter(end, 'm')) {
          end = oe;
        }
      }
    })

    if (moment(start).minute() !== 0) {
      start = moment(start).minute(0)
    }

    if (moment(end).minute() !== 0) {
      end = moment(end).minute(0).add(1, 'h')
    }

    return [start, end];
  }

  private concatAllReservations (hourReservations = [], checkinReservation, checkoutReservation) {
    const result = [...hourReservations];

    if (checkinReservation) {
      const unifiedCheckinReservation = this.unifiedReservationTimeFormat(checkinReservation, 'checkin');
      result.push(unifiedCheckinReservation);
    }

    if (checkoutReservation) {
      const unifiedCheckoutReservation = this.unifiedReservationTimeFormat(checkoutReservation, 'checkout');
      result.unshift(unifiedCheckoutReservation);
    }

    return result;

  }

  /**
   * @TODO 考虑使用start和end的差进行比较，遍历交换index位置。冒泡排序？ 递归？
   */
  private determineOrdersPosition (list: Array<any>) {

    const occupiedIndex = list.map(order => order['_index_']);
    const waitAllocatedIndex = this.allocateIndex(occupiedIndex);

    list.forEach((order, index) => {
      if (!order['_iflag_']) {
        order['_iflag_'] = true;
        order['_index_'] = waitAllocatedIndex.shift();
      }
    })
  }

  private determineOrdersStyle (list: Array<any>) {
    const occupiedWidth = list.reduce((total, current) => total + (current['_width_'] || 0), 0);

    const remainedWidth = 100 - occupiedWidth;
    const remainedCount = list.filter(order => !order['_wflag_']).length;

    list.forEach((order, index) => {
      if (!order['_wflag_']) {
        // const style = this.getOrderStyle(order.start, order.end);
        const style = this.getOrderStyle(order);

        const preWidth = list.slice(0, index).reduce((total, current) => total + current['_width_'], 0) || 0;

        let width = remainedWidth / remainedCount;
        const pre = list[index - 1];
        const nex = list[index + 1];
        if (nex && nex['_left_']) {
          if (!pre) {
            width = nex['_left_'];
          } else {
            width = nex['_left_'] - preWidth;
          }
        }

        order['_wflag_'] = true;
        order['_width_'] = width;
        order['_left_'] = preWidth;
        // console.log('[hour-calendar] determine order : ', order.client.name, ' prewidth: ', preWidth);
        order['style'] = { ...style, width: `${width}%`, left: `${preWidth}%` }
      }
    });
  }

  private getOrderStyle (order) {

    const { start, end, handmade_channel = 15} = order;

    const range = moment(this.rangeEnd).diff(this.rangeStart, 'm'); // 总时间跨度，单位分钟
    const px = range / 60 * this.timelineHeight; // 总高度，单位像素

    const pxPerMinute = px / range; // 每分钟代表的像素高度

    const height = moment(end).diff(start, 'm') * pxPerMinute;
    const top = moment(start).diff(this.rangeStart, 'm') * pxPerMinute;

    // const backgroundColor =  _.isEmpty(this.channelColorMap) ? 'transparent' : this.channelColorMap[handmade_channel].color;

    return {
      height, top
    };
  }

  private unifiedHourReservationsTimeFormat (list) {
    return list.map(order => {

      const date = moment(order.check_in).format('YYYY-MM-DD')
      const start = moment(`${date} ${order.hour_reservation_start_time}`).format('YYYY-MM-DD HH:mm');
      const end = moment(`${date} ${order.hour_reservation_end_time}`).format('YYYY-MM-DD HH:mm');

      return { ...order, start, end, type: 'hour_reservation' };
    });
  }

  private unifiedReservationTimeFormat (reservation, type: 'checkin' | 'checkout') {
    const date = moment(reservation.check_in).format('YYYY-MM-DD')

    if (type === 'checkin') {
      const start = moment(`${date} ${reservation.checkin_time.check_in_time}`).format('YYYY-MM-DD HH:mm');
      const end = moment(start).add(1, 'h').format('YYYY-MM-DD HH:mm');
      return { ...reservation, start, end, type: 'checkin_reservation' };
    } else {
      const end = moment(`${date} ${reservation.checkin_time.check_out_time}`).format('YYYY-MM-DD HH:mm');
      const start = moment(end).subtract(1, 'h').format('YYYY-MM-DD HH:mm');
      return { ...reservation, start, end, type: 'checkout_reservation' };
    }

  }

  private sortHourReservationsByTime (list) {
    return list.sort((a, b) => moment(a.start).diff(b.start, 'm'));
  }

  private sortOrdersByPosition (list) {
    return list.sort((a, b) => a['_index_'] - b['_index_']);
  }

  private findOrdersConflictWithEachOther (list) {
    const result = [];

    // this.listOfOrder = this.listOfOrder.sort((a, b) => {
    //   return moment(a.start).diff(b.start, 'm')
    // });

    const length = list.length;
    for (let i = 0; i < length; i++) {
      const base = list[i];

      const conflicts = list.filter(order => this.isConflict(
        order.start, order.end, base.start, base.end
      ) && base !== order);
      // console.log('listOfOrderCopy: ', conflicts, ' base: ', base.name);

      const conflictsArr = [  ];

      conflicts.forEach(order => {
        if (this.isConflictWithAll(
          order.start, order.end, conflictsArr
        )) {
          conflictsArr.push(order);
        }
      });

      result.push([ base, ...conflictsArr ]);
    }

    // let res = {};
    // result.forEach(item => {
    //   item.sort((a, b) => a.reservation_code > b.reservation_code);
    //   res[item] = item;
    // });
    // return Object.values(res);
    return result;

  }

  private isConflict (
    leftStartTime,
    leftEndTime,
    rightStartTime,
    rightEndTime,
  ) {
    return moment(rightStartTime).isBetween(leftStartTime, leftEndTime, 'm', '[)')
        || moment(leftStartTime).isBetween(rightStartTime, rightEndTime, 'm', '[)')
        || moment(leftEndTime).isBetween(rightStartTime, rightEndTime, 'm')
        || moment(rightEndTime).isBetween(leftStartTime, leftEndTime, 'm');
  }

  private isConflictWithAll (
    leftStartTime,
    leftEndTime,
    list: Array<any>
  ) {
    return list.every(item => this.isConflict(leftStartTime, leftEndTime, item.start, item.end));
  }

  private fetchSetting () {
    this.http.get(this.settingApi).subscribe(res => {
      const channels = _.get(res, 'data.reservation_channel') || [];
      this.channelColorMap = _.keyBy(channels, 'code');

      this.initOrdersInfo();
    });
  }

}
